import React from 'react'
import {Navigate, Route, Routes, useLocation} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {Settings} from './components/settings/Settings'
import {VendorHeader} from './VendorHeader'
import {VendorBankDetail} from './components/settings/cards/VendorBankDetail'
import {useMenuContext} from '../contexts/MenuContext'

const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Vendor',
    path: '/vendordetail/vendordocument',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const VendorDetailPage: React.FC = () => {
  const {allowedPaths} = useMenuContext()

  return (
    <Routes>
      <Route
        element={
          <>
            <VendorHeader />
            {/* <Outlet /> */}
          </>
        }
      >
        {allowedPaths.includes('../viewvendor/') && (
          <Route
            path='personaldetail'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Personal Detail</PageTitle>
                <Settings />
              </>
            }
          />
        )}

        <Route
          path='bankdetail'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Bank Detail</PageTitle>
              <VendorBankDetail />
            </>
          }
        />
        <Route
          path='hotels'
          element={
            <>
              <PageTitle breadcrumbs={accountBreadCrumbs}>Hotels</PageTitle>
            </>
          }
        />

        <Route index element={<Navigate to='/vendordetail/personaldetail' />} />
      </Route>
    </Routes>
  )
}

export default VendorDetailPage
